import { collection, getFirestore, limit, onSnapshot, query, where } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { Shipment } from '../../Models';
import { app } from '../firebase';
import shipmentConverter from './converters';

const db = getFirestore(app);

const deliveriesSubscription = (onLoad: (deliveries: Shipment[]) => void) =>
    onSnapshot(
        query(
            collection(db, 'deliveries'),
            where('pharmacy_id', '==', getAuth(app).currentUser?.uid),
            where('state', 'not-in', ['discarded', 'archived']),
            limit(300), // todo agregar creation_timestamp para reducir la cantidad de lecturas
        ).withConverter(shipmentConverter),
        (querySnapshot) => {
            const deliveries: Shipment[] = [];
            querySnapshot.forEach((docSnap) => {
                const delivery = docSnap.data();
                if (docSnap.exists()) {
                    deliveries.push(delivery);
                }
            });
            onLoad(deliveries);
        },
    );

export default deliveriesSubscription;
